module.exports = __webpack_public_path__ + "static/img/indexbg5.b9ff630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexbg5.png
// module id = oNwn
// module chunks = 1